<div class="car-panel" style="width: 80vw;">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="car-progress-bar" *ngIf="!enregistrementTerminer">
    <div class="car-progress-bar__inner"></div>
  </div>

  <div class="car-panel__header">
    <div class="car-panel__header-left">
      <span class="car-panel__icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
      </span>
      Liste articles
    </div>
    <div class="car-panel__header-actions">
      <button type="button" (click)="modifier()" class="car-btn car-btn--success car-btn--sm">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
        Modifier / Consulter
      </button>

      <button type="button" (click)="supprimer()" [disabled]="disabledBtnSupprimer"
        class="car-btn car-btn--danger car-btn--sm">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
          <path d="M10 11v6M14 11v6" />
          <path d="M9 6V4h6v2" />
        </svg>
        Supprimer
      </button>
    </div>
  </div>

  <div class="car-panel__body">
    <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="article"
      placeholder="Rechercher un article…">
    </app-recherche>
  </div>

</div>